export default "__VITE_ASSET__BGbjcxrm__";